import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import {ref} from "vue";
import EventManager from '../service/AppEventManagerService';


export default /*#__PURE__*/_defineComponent({
  __name: 'FlashMessengerComponent',
  setup(__props) {

const messages = ref([]);

EventManager.on('flash-message', (payload) => {
    const o = {
        type: payload['type'], body: payload['body'], duration: payload['duration'], isVisible: false, isPending: true, ts: Date.now()
    };
    messages.value.push(o);
});

setInterval(() => {
    let hasVisible = false;
    for (const i in messages.value) {
        if (messages.value[i].isVisible) {
            hasVisible = true;
        }
        if (messages.value[i].isPending && Date.now() - messages.value[i].ts > 100) {
            messages.value[i].isVisible = true;
            messages.value[i].isPending = false;
        } else {
            if (messages.value[i].isVisible) {
                if (Date.now() - messages.value[i].ts > 5000) {
                    messages.value[i].isVisible = false;
                }
            }
        }
    }
    if (messages.value.length > 100) {
        //@ts-ignore
        messages.value.splice(0, 50);
    }
}, 500)

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message) => {
    return (_openBlock(), _createBlock(_component_v_snackbar, {
      modelValue: message['isVisible'],
      "onUpdate:modelValue": ($event: any) => ((message['isVisible']) = $event),
      "multi-line": "",
      color: message['type'],
      location: "top right"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_icon, {
          icon: "mdi-close-circle",
          onClick: ($event: any) => (message['isVisible'] = false)
        }, null, 8 /* PROPS */, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(message['body']) + " ", 1 /* TEXT */)
      ]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "color"]))
  }), 256 /* UNKEYED_FRAGMENT */))
}
}

})